import { Action as ReduxAction } from 'redux';

namespace ContentStorageAction {
  export enum ActionType {
    PUT = 'CONTENT_STORAGE_PUT',
    REMOVE = 'CONTENT_STORAGE_REMOVE',
  }

  export interface PutAction extends ReduxAction {
    type: ActionType.PUT;
    key: string;
    value: string;
  }

  export interface RemoveAction extends ReduxAction {
    type: ActionType.REMOVE;
    key: string;
  }

  export const put = (key: string, value: string): PutAction =>
    ({ key, value, type: ActionType.PUT });
  export const remove = (key: string): RemoveAction =>
    ({ key, type: ActionType.REMOVE });

  export type Action = PutAction | RemoveAction;

  export function isDomesticAction(action: ReduxAction): action is Action {
    return Object.keys(ActionType).some(k => action.type === ActionType[k as any]);
  }
}

export default ContentStorageAction;
